import React from 'react';

/* Поля правильного ответа с возможностью добавить ещё.

   Один ответ — обычное поле, как было. Нажал «Добавить ответ» — появляется
   второе поле, и дальше верным считается ЛЮБОЙ из введённых. Нужно, когда одно
   и то же записывается по-разному: «0,25» и «0.25», «25%» и «1/4».

   Хранится всё в одном поле correctAnswer через перевод строки, а режим —
   отдельным флагом anyOfAnswers. Флаг нужен потому, что тем же разделителем
   записан другой случай: №26–27 ЕГЭ, где ученик даёт ВСЕ ответы по порядку и
   за каждый идёт свой балл. Без флага эти два режима не различить. */

const IcPlus = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round">
    <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);
const IcX = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export const splitAnswers = (value) => {
  const parts = String(value ?? '').split('\n');
  return parts.length ? parts : [''];
};
export const joinAnswers = (list) => list.map(x => String(x ?? '').trim()).filter(Boolean).join('\n');

export default function AnswerFields({ value, onChange, anyOf, onAnyOfChange, inputStyle, inputClass = '', placeholder = 'напр. 42' }) {
  // В режиме «любой подходит» показываем все поля, иначе — одно
  const list = anyOf ? splitAnswers(value) : [String(value ?? '')];

  const setAt = (i, v) => {
    const next = [...list];
    next[i] = v;
    onChange(anyOf ? next.join('\n') : v);
  };

  const add = () => {
    if (!anyOf) {
      onAnyOfChange(true);
      onChange(`${String(value ?? '').trim()}\n`);
      return;
    }
    onChange(`${list.join('\n')}\n`);
  };

  const remove = (i) => {
    const next = list.filter((_, k) => k !== i);
    // остался один — возвращаемся к обычному полю
    if (next.length <= 1) {
      onAnyOfChange(false);
      onChange(next[0] || '');
      return;
    }
    onChange(next.join('\n'));
  };

  return (
    <div className="ans-fields">
      {list.map((v, i) => (
        <div key={i} className="ans-row">
          <input className={inputClass} value={v} onChange={e => setAt(i, e.target.value)}
            placeholder={i === 0 ? placeholder : 'ещё вариант записи'} style={inputStyle} />
          {anyOf && list.length > 1 && (
            <button type="button" className="ans-x" onClick={() => remove(i)}
              title="Убрать этот вариант" aria-label="Убрать вариант"><IcX /></button>
          )}
        </div>
      ))}
      <button type="button" className="ans-add" onClick={add}>
        <IcPlus />Добавить ответ
      </button>
      {anyOf && list.length > 1 && (
        <p className="ans-hint">Засчитывается любой из этих ответов</p>
      )}
    </div>
  );
}
